import React from "react";
import "./index.scss";

const BasicButton = ({ text, onClick, color }) => {
    return (
        <div className={`basic-button-wrapper-v2 ${color}`} onClick={onClick}>   
            <div className="text-container">
                <div className="text">
                    <span>{text}</span>
                    <img className="arrow-img" src={"https://front.videomonster.com/images-7cuytg20/web/arrow_w.svg"} alt="arrow" />
                </div>
            </div>
        </div>
    )
};

export default BasicButton;

